import type { GameAppointment } from '../services/appointments';

export const sortAppointments = (itemA: GameAppointment, itemB: GameAppointment) => {
  return itemA.id - itemB.id;
};
